export const truncateText = (str: string, maxLen = 60) => str.length > maxLen ? str.slice(0, maxLen - 3) + '...' : str;